/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_03_LabelInputs */

const en_landing_section_03_label = /** @type {(inputs: Landing_Section_03_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real results`)
};

const de_landing_section_03_label = /** @type {(inputs: Landing_Section_03_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echte Ergebnisse`)
};

const fr_landing_section_03_label = /** @type {(inputs: Landing_Section_03_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real results`)
};

const es_landing_section_03_label = /** @type {(inputs: Landing_Section_03_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real results`)
};

const it_landing_section_03_label = /** @type {(inputs: Landing_Section_03_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real results`)
};

const nl_landing_section_03_label = /** @type {(inputs: Landing_Section_03_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real results`)
};

const pl_landing_section_03_label = /** @type {(inputs: Landing_Section_03_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real results`)
};

const fi_landing_section_03_label = /** @type {(inputs: Landing_Section_03_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real results`)
};

const da_landing_section_03_label = /** @type {(inputs: Landing_Section_03_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real results`)
};

const sv_landing_section_03_label = /** @type {(inputs: Landing_Section_03_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real results`)
};

/**
* | output |
* | --- |
* | "Real results" |
*
* @param {Landing_Section_03_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_03_label = /** @type {((inputs?: Landing_Section_03_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_03_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_03_label(inputs)
	if (locale === "fr") return fr_landing_section_03_label(inputs)
	if (locale === "es") return es_landing_section_03_label(inputs)
	if (locale === "it") return it_landing_section_03_label(inputs)
	if (locale === "nl") return nl_landing_section_03_label(inputs)
	if (locale === "pl") return pl_landing_section_03_label(inputs)
	if (locale === "fi") return fi_landing_section_03_label(inputs)
	if (locale === "da") return da_landing_section_03_label(inputs)
	if (locale === "sv") return sv_landing_section_03_label(inputs)
	return en_landing_section_03_label(inputs)
});